import Vue from 'vue';
import { DataService } from '../../data.service';
import { landcoverClasses as legend } from '../../../config/chart-legends';

const chartID = 'getCountyForestDistribution';
/**
 * Tab 3: Forests: Distribution Of Forest By Forest Type
 * getCountyForestDistribution
 */
export class Tab3Chart5 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas[0]);
                this.updateChartData(response.data.LandCoverAtlas[0], response.data.fromYear, response.data.toYear);
            }
        })
        this.renderChart();
    }

    updateChartData(response, fromYear, toYear) {
        this.chart.chartOptions.series[0].data = response.data.startDate;
        this.chart.chartOptions.series[0].name = fromYear;
        this.chart.chartOptions.series[1].data = response.data.endDate;
        this.chart.chartOptions.series[1].name = toYear;
        this.chart.chartOptions.xAxis.categories = response.categoryAbbr;
        this.chart.infographic.loading = false;
    }

    renderChart() {
        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        title: 'Distribution Of Forest By Forest Type',
                        loading: true
                    },
                    animationDuration: 1000,
                    updateArgs: [true, true, { duration: 1000 }],
                    chartOptions: {
                        chart: {
                            type: 'bar',
                            marginTop: 40
                        },
                        colors: ['#5B6E35', '#9BBB59'],
                        xAxis: {
                            title: {
                                text: 'Forest Type'
                            },
                            categories: ['DFO', 'EFO', 'MFO'],
                        },
                        yAxis: {
                            title: {
                                text: 'Square Miles'
                            }
                        },
                        tooltip: {
							shared: true,
                            formatter: function () {
								let tooltip = '';
								for(let i=0; i < this.points.length; i++) {
									if(i != 0) {
										tooltip += '<br>-------<br>'
									}
									tooltip += '<b>' + this.points[i].series.name + '</b><br>' + legend[this.x].name + '<br><b>' + this.points[i].y + '</b> square miles';
								}
								return tooltip;
                            }
                        },
                        series: [
                            {
                                name: '1996',
                                data:
                                    [
                                        224.52, 58.90, 15.06
                                    ]
                            },
                            {
                                name: '2010',
                                data:
                                    [
                                        261.76, 58.90, 16.45
                                    ]
                            }
                        ]
                    }
                }
            }
        });
        //end vue component

    }
}
